export enum SoundTag {
	JUMP = "jump_sound",
	DOUBLE_JUMP = "double_jump_sound",
	GAME_OVER = "game_over_sound",
	LEVEL_UP = "level_up_sound",
	FIRE = "fire_sound",
	FIRE_BALL_BOSS_LOOP = "fire_ball_boss_loop_sound",
	IMPACT_INVINCIBLE = "invincible_impact_sound",
	IMPACT = "impact_sound",
	IMPACT_BOSS = "boss_impact_sound",
	SHOCKWAVE_BOSS_LOOP = "shockwave_boss_loop_sound",
}
